import { PremiumFeatureType } from '../services/premiumService';

export class UpgradeRequiredError extends Error {
  public requiresUpgrade: boolean;
  public upgradeType: PremiumFeatureType;
  public price: number;
  public reason: string;

  constructor(data: {
    message: string;
    requiresUpgrade: boolean;
    upgradeType: PremiumFeatureType;
    price: number;
  }) {
    super(data.message);
    this.name = 'UpgradeRequiredError';
    this.requiresUpgrade = data.requiresUpgrade;
    this.upgradeType = data.upgradeType;
    this.price = data.price;
    this.reason = data.message;
  }
}

export interface PremiumErrorResponse {
  requiresUpgrade?: boolean;
  upgradeType?: PremiumFeatureType;
  price?: number;
}